import { Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import { SuccessFeeTier } from '../../shared/models';
import { NumberUtils } from '../../shared/utils';

interface SuccessFeeTierTableDisplayProps {
	tiers: SuccessFeeTier[];
}

export const SuccessFeeTierTableDisplay: React.FC<SuccessFeeTierTableDisplayProps> = ({ tiers }) => {
	if (!tiers || tiers.length == 0) return <></>;

	return (
		<Table sx={{ marginBottom: 1 }}>
			<TableHead>
				<TableRow>
					<TableCell>Range</TableCell>
					<TableCell>BPS</TableCell>
				</TableRow>
			</TableHead>
			<TableBody>
				{tiers.map(tier => {
					return (
						<TableRow key={tier.guid}>
							<TableCell>
								{NumberUtils.FormatNumber(tier.lowerFundingAmount, 'abbreviation')} -{' '}
								{NumberUtils.FormatNumber(tier.upperFundingAmount, 'abbreviation')}
							</TableCell>
							<TableCell>{tier.basisPoints}</TableCell>
						</TableRow>
					);
				})}
			</TableBody>
		</Table>
	);
};
